import React, { useCallback } from "react";
import { Header, Button, FormInput } from "../UI";
import { useAdditionalEmails } from "../../hooks/useAdditionalEmails";

export function AdditionalEmailsSection({
  formValues,
  onChange,
  readOnly,
  getInputProps,
  showValidationErrors,
  translate,
}) {
  const {
    blurredAdditionalEmails,
    handleAddEmail,
    removeClick,
    addEmailInput,
    handleAdditionalEmailBlur,
  } = useAdditionalEmails(formValues, onChange);

  const handleInputChange = useCallback(
    (event) => {
      onChange(event.target.name, event.target.value);
    },
    [onChange]
  );

  const additionalEmailInputs = (formValues.additionalEmails || []).map(
    (el, i) => (
      <div key={i} className="row">
        <div
          className={readOnly ? "col-12" : "col-10"}
          onBlur={(event) => {
            if (!event.currentTarget.contains(event.relatedTarget)) {
              handleAdditionalEmailBlur(i);
            }
          }}
        >
          <FormInput
            {...getInputProps({
              label: "",
              id: `additional-email-${i}`,
              name: `additionalEmail${i}`,
              required: false,
              type: "text",
              inputMode: "email",
              pattern: "^[A-Za-z0-9._+\\-]+@[A-Za-z0-9.\\-]+\\.[A-Za-z]{2,}$",
              "data-pattern-message": "ERROR_EMAIL_PATTERN",
              maxLength: 100,
              autoComplete: "email",
              readOnly: readOnly,
              value: el || "",
              displayError:
                showValidationErrors || blurredAdditionalEmails.has(i),
              onChange: (event) => handleAddEmail(i, event),
            })}
          />
        </div>
        {!readOnly && (
          <div className="col-2 mt-2 text-center">
            <Button
              variant="link"
              type="button"
              className="pr-0 pl-0"
              title={translate("BUTTON_REMOVE")}
              onClick={() => removeClick(i)}
            >
              <i className="fas fa-times-circle"></i>
            </Button>
          </div>
        )}
      </div>
    )
  );

  return (
    <div className="mb-5">
      <div className="border-bottom mb-3">
        <Header level={2}>{translate("HEADER_EMAIL_FOR_ORDER")}</Header>
      </div>

      <div className="row">
        <div className="col-sm-6">
          <FormInput
            {...getInputProps({
              label: translate("LABEL_EMAIL"),
              id: "email",
              name: "email",
              required: true,
              type: "email",
              maxLength: 100,
              autoComplete: "email",
              readOnly: true,
              value: formValues.email,
              onChange: handleInputChange,
            })}
          />

          {!readOnly && (
            <p className="fa-sm mb-0">
              <i>{translate("MESSAGE_EMAIL_ADD_LIMIT")}</i>
            </p>
          )}

          {!readOnly && additionalEmailInputs.length <= 4 && (
            <div>
              <Button
                variant="link"
                className="p-0"
                onClick={addEmailInput}
                type="button"
              >
                {translate("BUTTON_ADD_EMAIL")}
              </Button>
            </div>
          )}

          {additionalEmailInputs.length <= 5 &&
            additionalEmailInputs.length >= 1 && (
              <div>
                <Header level={4} className="mt-4">
                  {translate("HEADER_ADDITIONAL_EMAILS")}
                </Header>
              </div>
            )}

          {additionalEmailInputs}
        </div>
      </div>
    </div>
  );
}